/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var email_validator_1 = __importDefault(require("email-validator"));

var phone_1 = __importDefault(require("phone"));

var postal_codes_js_1 = __importDefault(require("postal-codes-js"));

var brightsmith_core_1 = require("brightsmith-core");

var Helper = {
  standardFields: {
    firstName: {
      type: 'text',
      order: 1,
      placeholder: 'First Name',
      required: true
    },
    lastName: {
      type: 'text',
      order: 2,
      placeholder: 'Last Name',
      required: true
    },
    email: {
      type: 'text',
      order: 3,
      placeholder: 'Email',
      required: true,
      validate: function validate(formData, isRequired, opts) {
        var emailVal = formData.email;

        if (!emailVal) {
          if (isRequired) {
            return false;
          }

          return true;
        }

        return email_validator_1.default.validate(emailVal);
      }
    },
    address: {
      type: 'text',
      order: 4,
      placeholder: 'Address',
      required: true
    },
    address2: {
      type: 'text',
      order: 4,
      placeholder: 'Address 2'
    },
    city: {
      type: 'text',
      order: 5,
      placeholder: 'City',
      required: true
    },
    state: {
      type: 'select',
      options: function options() {
        var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'US';
        console.log('state.options', country, brightsmith_core_1.PROVINCES);
        var options = typeof country === 'string' ? brightsmith_core_1.PROVINCES[country] : brightsmith_core_1.PROVINCES[country.value];
        return (options || []).map(function (o) {
          return {
            label: o.name,
            value: o.short
          };
        });
      },
      order: 6,
      placeholder: 'State',
      required: true
    },
    country: {
      type: 'select',
      defaultValueIndex: 0,
      options: [{
        label: 'US',
        value: 'US'
      }, {
        label: 'Canada',
        value: 'CA'
      }],
      order: 7,
      placeholder: 'Country',
      required: true
    },
    zip: {
      type: 'text',
      order: 8,
      placeholder: 'Zip Code / Postal Code',
      required: true,
      validate: function validate(formData, isRequired, opts) {
        var _a;

        var zipCode = formData.zip;
        var countryCode = ((_a = formData === null || formData === void 0 ? void 0 : formData.country) === null || _a === void 0 ? void 0 : _a.value) || (opts === null || opts === void 0 ? void 0 : opts.countryCode);

        if (!zipCode) {
          if (isRequired) {
            return false;
          }

          return true;
        }

        return postal_codes_js_1.default.validate(countryCode, zipCode) === true;
      }
    },
    phone: {
      type: 'phone',
      order: 9,
      placeholder: 'Phone Number',
      required: true,
      validate: function validate(formData, isRequired, opts) {
        var _a;

        var phoneNum = formData.phone;
        var countryCode = (_a = formData === null || formData === void 0 ? void 0 : formData.country) === null || _a === void 0 ? void 0 : _a.value;

        if (!phoneNum) {
          if (isRequired) {
            return false;
          }

          return true;
        }

        return phone_1.default(phoneNum, countryCode).length > 0;
      }
    },
    signUp: {
      type: 'check',
      label: 'Sign up for emails',
      order: 10
    }
  },
  getFormFields: function getFormFields(props) {
    var propFields = props.fields;
    var formFields = this.standardFields;

    if (propFields) {
      Object.keys(propFields).forEach(function (key) {
        if (!formFields[key]) {
          formFields[key] = {};
        }

        if (propFields[key]) {
          formFields[key] = Object.assign({}, formFields[key], propFields[key]);
        } else {
          delete formFields[key];
        }
      });
    }

    var sortedFields = Object.keys(formFields).map(function (name) {
      var fieldObj = formFields[name];
      fieldObj.key = name;
      return fieldObj;
    }).sort(function (a, b) {
      return (a.order || 0) - (b.order || 0);
    });
    return sortedFields;
  },
  getInitialFormData: function getInitialFormData(props) {
    var formData = {};
    var formFields = this.getFormFields(props);
    formFields.forEach(function (field) {
      var defaultValue = field.defaultValue,
          defaultValueIndex = field.defaultValueIndex,
          key = field.key,
          options = field.options;

      if (defaultValue !== undefined) {
        formData[key] = defaultValue;
      }

      if (defaultValueIndex !== undefined && options) {
        formData[key] = options[defaultValueIndex];
      }
    });
    return formData;
  }
};
exports.default = Helper;